import { Button, Card, Col, Container, DatePicker, Form, FormCheckbox, FormSelect, ListGroup, ListGroupItem, Row } from "shards-react";
import InfoTooltip from "../../../components/common/InfoTooltip";
import { useEffect, useRef, useState } from "react";
import { setAlert } from "../../../redux/actions/alert";
import { validateFileName } from "../../../utils/general";
import { connect } from "react-redux";
import { get_pay_schedule_list, get_payperiod_list, get_payroll_taximort_type, save_import_data } from "../../../redux/actions/subscriber/payroll";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { setInputDate } from "../../../utils/date";
import { get_subscriber_default_payschedule } from "../../../redux/actions/subscriber/subscriberUsers";

function ImportData({
    payrollTaxImportType,
    payPeriodList,
    setAlert,
    save_import_data,
    get_payroll_taximort_type,
    get_payperiod_list,
    payScheduleList,
    get_pay_schedule_list,
    get_subscriber_default_payschedule,
    subscriberDefaultPaySchedule,
}) {

    let {id} = useParams();
    const [formData, setFormData] = useState({
        importType: '',
        payPeriod: '',
        importDuplicates: false,
        startDate: '',
        file: null,
        paySchedule: '',
    })
    const [ payPeriodOption, setPayPeriodOption ] = useState([]);

    const [isSubmitting, setSubmitting] = useState(false);
    const fileRef = useRef(null)
    const history = useHistory();
    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const resetFile = () => {
        if (fileRef.current) {
            fileRef.current.value = "";
        }
    };
    const onFileChange = (e) => {
        e.preventDefault();
        const supportedExtensions = ['.csv', '.CSV', '.xlsx', '.XLSX'];
        //const supportedExtensions = formData.importType === 'Payroll Tax' ? ['.csv', '.CSV'] : ['.xlsx', '.XLSX'];
        let file = e.target.files[0];
        if(file === undefined) {
            resetFile();
            return;
        }
        let fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
        let valid = validateFileName(file.name);

        if (!valid) {
            setAlert("File name should only contain letters [a-z, A-Z], numbers [0-9], space [' '], period [.], underscore [_] and hyphen [-].", "danger");
            resetFile();
            return;
        }
        if (!supportedExtensions.includes(fileExtension.toLowerCase())) {
            //setAlert(`Please attach  ${formData.importType === 'Payroll Tax' ? '.CSV' : '.XLSX'} only.`, "danger");
            // change by nipul -> As per 2196 need to consider both the extension
            setAlert(`Please attach '.CSV' or '.XLSX' only.`, "danger");
            resetFile();
            return;
        }

        setFormData({ ...formData, file: file });
    }

    const payPeriodListOptions = (payPeriodList || []).map(payPeriod => <option key={payPeriod.payPeriodName} value={payPeriod.payPeriodName}>{payPeriod.payPeriodName}</option>)
    const payrollTaxImportTypeOptions = (payrollTaxImportType || []).map(importType => <option key={importType} value={importType}>{importType}</option>)
    const payScheduleListOptions = (payScheduleList || []).map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)

    const payrollData = (payrollTaxImportType || []).filter(x => { return x.includes("Payroll") })
    const benefitCompensData = (payrollTaxImportType || []).filter(x => { return x.includes("Benefits") || x.includes("Compensation") })
    const rateTablesData = (payrollTaxImportType || []).filter(x => {
        return x.includes("Worker Comp") || x.includes("Health")
            || x.includes("Government") || x.includes("Employment")
    })
    const timesheetData = (payrollTaxImportType || []).filter(x => { return x.includes("Timesheets") })
    const userData = (payrollTaxImportType || []).filter(x => { return x === "Worker" || x === "Client User" || x === "Client" }) 
    const payableData = (payrollTaxImportType || []).filter(x => { return x === "Invoice" || x === "Payable" || x === "Payment" })

    const groupPayables = <optgroup label="======================= "> {
        payableData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;
    const groupPayrollTax = <optgroup label="======================= "> {
        payrollData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;

    const groupBenefits = <optgroup label="======================= "> {
        benefitCompensData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;

    const groupRateTables = <optgroup label="======================= "> {
        rateTablesData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;

    const groupTimesheet = <optgroup label="======================= "> {
        timesheetData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;

    const groupUser = <optgroup label="======================= "> {
        userData.map(importType => <option key={importType} value={importType}>{importType}</option>)} </optgroup>;

    const onSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        setSubmitting(true);
        const formDataToSubmit = { ...formData };
        if (formDataToSubmit.importType === "Timesheets" || formDataToSubmit.importType === "Payroll Tax"
            || formDataToSubmit.importType === "Payroll Tax-Mpex"
        ) {
            //Do validate -- Removed pay period validation
            if (formDataToSubmit.paySchedule === "") {
                setAlert("Please select Pay Schedule!", "danger");
                return false;
            }
            if (formDataToSubmit.file === null) {
                setAlert("Please upload file!", "danger");
                return false;
            }
        }

        formDataToSubmit.startDate = setInputDate(formDataToSubmit.startDate);
        const saved = await save_import_data({ ...formDataToSubmit });
        if(Number(saved) > 0) {
            if (formDataToSubmit.importType === "Payroll Tax" || formDataToSubmit.importType === "Payroll Tax-Mpex") {
                history.push({
                    pathname: `/import-log-details`,
                    state: { refNum: saved }
                });
            }
        }
        // if(saved) 
        //     history.goBack();
        // else
        setSubmitting(false);

    }

    useEffect(() => {
        get_payroll_taximort_type();
        get_payperiod_list();
        get_pay_schedule_list();
        get_subscriber_default_payschedule();
    }, [])

    useEffect(() => {
        let url = window.location.href.toString();
        let option = url.substring(url.lastIndexOf('/') + 1, url.length);
        if(option === 'timesheet'){
            setFormData({ ...formData, importType: 'Timesheets - PHRBO Format'})
        }

    }, [payrollTaxImportType])

    const getFilePathForImport = (type) => {
        let href = "";
        let fileName = "";

        switch (type) {
            case 'Timesheets - PHRBO Format':
                href = "/sampleFile/Timesheet-Import-Format.xlsx";
                fileName = "Timesheet-Import-Format.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;
            case 'Timesheets - Clockify Format':
                href = "/sampleFile/Clockify-Time-Report-Detailed.csv";
                fileName = "Clockify-Time-Report-Detailed.csv";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Payroll Tax':
                href = "/sampleFile/Payroll-Tax.csv";
                fileName = "Payroll-Tax.csv";
                prepareAnchorToDownload(href, fileName);
                break;
            case 'Payroll Tax-Mpex':
                href = "/sampleFile/PayrollTax-Import-Mpex.xlsx";
                fileName = "PayrollTax-Import-Mpex.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Benefits Data':
                href = "/sampleFile/Benefits_Import_File.xlsx";
                fileName = "Benefits_Import_File.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Compensation And Retirement':
                href = "/sampleFile/Compensation-And-Retirement.xlsx";
                fileName = "Compensation-And-Retirement.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Worker Comp':
                href = "/sampleFile/Worker-Compensation-Rates.csv";
                fileName = "Worker-Compensation-Rates.csv";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Health Tax':
                href = "/sampleFile/Health-Tax-Rates.csv";
                fileName = "Health-Tax-Rates.csv";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Government Pension':
                href = "/sampleFile/Government-Pension-Plan-Rates.csv";
                fileName = "Government-Pension-Plan-Rates.csv";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Government Pension 2':
                href = "/sampleFile/Government2-Pension-Plan-Rates.csv";
                fileName = "Government2-Pension-Plan-Rates.csv";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Worker':
                href = "/sampleFile/Import-Worker.xlsx";
                fileName = "Import-Worker.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Client':
                href = "/sampleFile/Import-Client.xlsx";
                fileName = "Import-Client.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Client User':
                href = "/sampleFile/Import-Client-User.xlsx";
                fileName = "Import-Client-User.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Invoice':
                href = "/sampleFile/Import-Invoice.xlsx";
                fileName = "Import-Invoice.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Payable':
                href = "/sampleFile/Import-Payable.xlsx";
                fileName = "Import-Payable.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            case 'Payment':
                href = "/sampleFile/Import-Payment.xlsx";
                fileName = "Import-Payment.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;

            default:
                href = "/sampleFile/Employment-Insurance-Rates.csv";
                fileName = "Employment-Insurance-Rates.csv";
                prepareAnchorToDownload(href, fileName);
                break;
        }
    }

    const prepareAnchorToDownload = (href, name) => {
        const link = document.createElement('a');
        link.href = href;
        link.download = name;
        link.click();
    }

    useEffect(() => {
        if(subscriberDefaultPaySchedule !== null && subscriberDefaultPaySchedule !== undefined)
            setFormData({ ...formData, paySchedule: subscriberDefaultPaySchedule?.payScheduleRefNum })
    }, [subscriberDefaultPaySchedule])

    useEffect(() => {
        if(payPeriodList !== null && payPeriodList !== undefined 
            && formData.paySchedule !== undefined && formData.paySchedule !== ""){
            let newOptions = (payPeriodList || []).filter(x => x.payScheduleRefNum == formData.paySchedule)
                .map(payPeriod => <option key={payPeriod.payPeriodName} value={payPeriod.payPeriodName}>{payPeriod.payPeriodName}</option>)
            setPayPeriodOption(newOptions);
            
        }
    }, [payPeriodList, formData.paySchedule])

    return (
        <Container fluid className="main-content-container p-4">
            <Card small className="mb-4 w-100 ">
                <ListGroup flush>
                    <Form onSubmit={onSubmit}>
                        <ListGroupItem className="border-card p-3 w-100">
                            <Row className="mb-3 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <label htmlFor="importType" className="w-50 mt-2">Import Type</label>
                                    <FormSelect
                                        name="importType"
                                        id="importType"
                                        value={formData.importType}
                                        onChange={onChange}
                                    >
                                        {/* {payrollTaxImportTypeOptions} */}
                                        <optgroup>
                                            <option key="importType0" value="">Select Import Type</option>
                                        </optgroup>
                                        {groupPayables}
                                        {groupPayrollTax}
                                        {groupBenefits}
                                        {groupRateTables}
                                        {groupTimesheet}
                                        {groupUser}

                                    </FormSelect>
                                </Col>
                                <Col lg="4" className="d-flex flex-row justify-content-between pl-5">
                                    {formData.importType !== "" ? <Button className="custom-margin-header" onClick={() => {
                                        getFilePathForImport(formData.importType);
                                    }}>
                                        Download Sample File Format
                                    </Button> : <></>}
                                </Col>
                                <Col lg="4" className="d-flex flex-row mt-2 importDataCheckboxAdjustment">
                                    <label htmlFor="importDuplicates" className="w-70">Do not import duplicates</label>
                                    <InfoTooltip cssClassName="text-start custom-tooltip-inner mt-1 mr-5"
                                        msg="For Ceridian Payroll tax: Rows with the same PPE and employee number <br/>that have been already imported will not be imported again." />

                                    <FormCheckbox
                                        name="importDuplicates"
                                        id="importDuplicates"
                                        value={formData.importDuplicates}
                                        checked={formData.importDuplicates}
                                        onChange={() => setFormData({ ...formData, importDuplicates: !formData.importDuplicates })}
                                    />
                                </Col>
                            </Row>
                            
                            <Row className="mb-3 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <label htmlFor="paySchedule" className="w-50 mt-2">Pay Schedule</label>
                                    <FormSelect
                                        value={formData.paySchedule}
                                        id="paySchedule"
                                        name='paySchedule'
                                        onChange={onChange}>
                                        <option value=''>Select Pay Schedule</option>
                                        {payScheduleListOptions}
                                    </FormSelect>
                                </Col>
                                
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <label htmlFor="payPeriod" className="w-50 mt-2">Pay Period</label>
                                    <FormSelect
                                        name="payPeriod"
                                        id="payPeriod"
                                        value={formData.payPeriod}
                                        onChange={onChange}
                                    >
                                        <option>Select Pay Period</option>
                                        {payPeriodOption}
                                    </FormSelect>
                                </Col>
                            </Row>
                            <Row className="mb-2 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between ">
                                    <label htmlFor="startDate" className="w-50 mt-2 mr-n2">Start Date</label>

                                    <DatePicker
                                        id='startDate'
                                        autoComplete='off'
                                        name='startDate'
                                        dateFormat='yyyy-MM-dd'
                                        value={formData.startDate}
                                        selected={formData.startDate}
                                        onChange={(date) =>
                                            setFormData({ ...formData, 'startDate': date })
                                        }
                                        placeholderText="YYYY-MM-DD"
                                    />

                                </Col>
                            </Row>
                            <Row className="mb-2 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <div>
                                        <label htmlFor="file" className="mt-2 w-50">File Upload</label>
                                        <input name="file" id="file" type="file" onChange={onFileChange} ref={fileRef} accept={'.csv, .xlsx'} />
                                    </div>
                                    <div className="d-flex align-items-end">
                                        <Button >Submit</Button>
                                    </div>

                                </Col>
                            </Row>
                        </ListGroupItem>
                    </Form>
                </ListGroup>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state => ({
    payScheduleList: state.payroll.payScheduleList,
    paySchedule: state.payroll.paySchedule,
    payrollTaxImportType: state.payroll.payrollTaxImportType,
    payPeriodList: state.payroll.payPeriodList,
    payScheduleList: state.payroll.payScheduleList,
    subscriberDefaultPaySchedule: state.subscriberUsers.subscriberDefaultPaySchedule,
}))
export default connect(mapStateToProps, {
    setAlert,
    save_import_data,
    get_payroll_taximort_type,
    get_payperiod_list,
    get_pay_schedule_list,
    get_subscriber_default_payschedule,
})(ImportData)